import {createSlice} from '@reduxjs/toolkit';
import reducers from './reducers'
import extraReducers from './extraReducers'
import { EMPTY_AUTH, IAuth, AuthStatus } from '../../types/auth';

export * from '../../thunk/auth';

const usersSlice = createSlice({
    name: "auth",
    initialState: {
        data: EMPTY_AUTH as IAuth,
        status: 'idle' as AuthStatus,
        error: null as any
    },
    reducers,
    extraReducers
});
const {actions, reducer} = usersSlice
export const {setAuthenticatedUser} = actions;
export {reducer};
export const selectToken = (state) => state.auth.data.token;
